import { View as ConfirmRecipientView } from './ConfirmRecipientView';

export { ConfirmRecipientView };
